import axios from 'axios';
import { getEndpoints } from './configs';
import { OnyoPaymentResponse } from '../model/payment-response';

export async function sendPaymentResponse(data: OnyoPaymentResponse, paymentId: number) {
  const endpoints = getEndpoints();
  const url = `${endpoints.api}v1/mobile/payment/${paymentId}/payment_response`;
  await axios.put(url, data);
}
